var exports = {
  "kL": "InlineEdit.module__container___MENXd2",
  "A": "InlineEdit.module__inlineTextBase___MENXd2",
  "Np": "InlineEdit.module__idleButton___MENXd2",
  "iE": "InlineEdit.module__wrapper___MENXd2",
  "qf": "InlineEdit.module__placeholder___MENXd2",
  "LL": "InlineEdit.module__editable___MENXd2",
  "NY": "InlineEdit.module__affix___MENXd2",
  "Qq": "InlineEdit.module__text___MENXd2",
  "z3": "InlineEdit.module__error___MENXd2",
};

module.exports = exports;
